import type { Competitor, ThemeData } from '../types';
import type { SeededRandom } from '../rng/SeededRandom';

export function createCompetitors(themeData: ThemeData, rng: SeededRandom): Competitor[] {
  return themeData.entities.competitors
    .filter((def) => def.startYear <= 1)
    .map((def) => ({
      id: def.id,
      name: def.name,
      reputation: 20,
      specialties: def.specialties,
      quality: def.startQuality,
      releaseTimer: rng.nextInt(
        def.releaseIntervalWeeks[0] * 70,
        def.releaseIntervalWeeks[1] * 70,
      ),
      products: [],
    }));
}

export function createLateCompetitor(
  themeData: ThemeData,
  competitorId: string,
  rng: SeededRandom,
): Competitor | null {
  const def = themeData.entities.competitors.find((c) => c.id === competitorId);
  if (!def) return null;

  return {
    id: def.id,
    name: def.name,
    reputation: 30,
    specialties: def.specialties,
    quality: def.startQuality,
    releaseTimer: rng.nextInt(
      def.releaseIntervalWeeks[0] * 70,
      def.releaseIntervalWeeks[1] * 70,
    ),
    products: [],
  };
}
